






























import Vue from 'vue';

interface Page {
  label: number;
  active: boolean;
  disable: boolean;
}

export default Vue.extend({
  name: 'SimplePagination',

  props: {
    value: Number,
    pageCount: Number,
  },

  computed: {
    items(): Page[] {
      const valPrev = this.value > 1 ? this.value - 1 : 1; // for easier navigation - gives one previous page
      const valNext = this.value < this.pageCount ? this.value + 1 : this.pageCount; // one next page
      const extraPrev = valPrev === 3 ? 2 : null;
      const extraNext = valNext === this.pageCount - 2 ? this.pageCount - 1 : null;
      const dotsBefore = valPrev > 3 ? 2 : null;
      const dotsAfter = valNext < this.pageCount - 2 ? this.pageCount - 1 : null;

      const output: Page[] = [];

      for (let i = 1; i <= this.pageCount; i += 1) {
        if (this.pageCount < 8) {
          output.push({
            label: i,
            active: this.value === i,
            disable: false,
          });
          continue;
        }

        if (
          [1, this.pageCount, this.value, valPrev, valNext, extraPrev, extraNext, dotsBefore, dotsAfter].includes(i) ||
          (i < 6 && this.value < 5) ||
          (i > this.pageCount - 5 && this.value > this.pageCount - 4)
        ) {
          output.push({
            label: i,
            active: this.value === i,
            disable: [dotsBefore, dotsAfter].includes(i),
          });
        }
      }

      return output;
    },

    onFirstPage(): boolean {
      return this.value === 1;
    },

    onLastPage(): boolean {
      return this.value === this.pageCount;
    },
  },

  methods: {
    prev(): void {
      if (!this.onFirstPage) {
        this.$emit('input', this.value - 1);
      }
    },

    goto(pageNum: number) {
      this.$emit('input', pageNum);
    },

    next(): void {
      if (!this.onLastPage) {
        this.$emit('input', this.value + 1);
      }
    },
  },
});
